export default __webpack_public_path__ + "static/media/facebook_logo.421fbabb.svg";